(() => {
  const HEADING_SELECTOR = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    '.h1', '.h2', '.h3', '.h4', '.h5', '.h6',
    '.logolink.text-logo',
    '.heading-font',
    '.h1-xlarge',
    '.h1-large',
    'blockquote p',
    'blockquote span',
    '.customer-addresses .my-address .address-index'
  ].join(',');

  const MATCHA_INITIAL_M_RE = /\b[Mm](?=atcha)/g;

  const italicizeMInHeadings = (root = document) => {
    const headings = root.querySelectorAll(HEADING_SELECTOR);

    headings.forEach((headingEl) => {
      const walker = document.createTreeWalker(headingEl, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node || !node.nodeValue) continue;
        MATCHA_INITIAL_M_RE.lastIndex = 0;
        if (!MATCHA_INITIAL_M_RE.test(node.nodeValue)) continue;
        if (node.parentElement && node.parentElement.closest('.rst-italic-m')) continue;
        textNodes.push(node);
      }

      textNodes.forEach((textNode) => {
        const text = textNode.nodeValue;
        if (!text) return;

        const frag = document.createDocumentFragment();

        MATCHA_INITIAL_M_RE.lastIndex = 0;
        let lastIndex = 0;
        let match;
        while ((match = MATCHA_INITIAL_M_RE.exec(text))) {
          const idx = match.index;
          if (idx > lastIndex) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex, idx)));
          }

          const span = document.createElement('span');
          span.className = 'rst-italic-m';
          span.textContent = text[idx];
          frag.appendChild(span);

          lastIndex = idx + 1;
        }

        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(frag, textNode);
      });
    });
  };

  const init = () => {
    italicizeMInHeadings(document);

    document.addEventListener('shopify:section:load', (e) => italicizeMInHeadings(e.target));
    document.addEventListener('shopify:section:reorder', (e) => italicizeMInHeadings(e.target));
    document.addEventListener('shopify:section:select', (e) => italicizeMInHeadings(e.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
